import { z } from "zod";

const zPartOfSpeech = z.enum(["noun", "verb"]);
const PartOfSpeech = zPartOfSpeech.Values;
type PartOfSpeech = z.infer<typeof zPartOfSpeech>;

const zPlural = z.enum(["one", "few", "many", "other"]);
const Plural = zPlural.Values;
type Plural = z.infer<typeof zPlural>;

const zCase = z.enum(["genitive", "accusative"]);
const Case = zCase.Values;
type Case = z.infer<typeof zCase>;

const zAnimateness = z.enum(["inanimate"]);
const Animateness = zAnimateness.Values;
type Animateness = z.infer<typeof zAnimateness>;

const zGender = z.enum(["feminine"]);
const Gender = zGender.Values;
type Gender = z.infer<typeof zGender>;

const zContext = z.enum(["infinitive"]);
const Context = zContext.Values;
type Context = z.infer<typeof zContext>;

export { Animateness, Case, Context, Gender, PartOfSpeech, Plural };
